import React from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Alert from '@amzn/meridian/alert';
import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

export type AlertType = 'success' | 'error' | 'warning' | 'informational';

export interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  alertType?: AlertType;
  alertSize?: 'small' | 'medium' | 'large' | 'xlarge';
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  showCancel?: boolean;
  ariaDescribedBy?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  title,
  message,
  alertType = 'informational',
  alertSize = 'medium',
  confirmText = 'OK',
  cancelText = 'Cancel',
  onConfirm,
  showCancel = false,
  ariaDescribedBy,
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  return (
    <Modal open={open} scrollContainer="viewport" aria-describedby={ariaDescribedBy} onClose={onClose}>
      <Text type="h400">{title}</Text>
      <Alert size={alertSize} type={alertType}>
        {message}
      </Alert>
      <ModalFooter>
        {showCancel ? (
          <Row spacing="400">
            <Button type="secondary" onClick={onClose}>
              {cancelText}
            </Button>
            <Button type="primary" onClick={handleConfirm}>
              {confirmText}
            </Button>
          </Row>
        ) : (
          <Button type="primary" onClick={handleConfirm}>
            {confirmText}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
